import {
  calculateMindedResources,
  type CalculateMindedResourcesData,
} from '@shared-libs/index';

const safeCalculateMindedResources = (
  plant: CalculateMindedResourcesData,
): number => {
  try {
    return calculateMindedResources(plant);
  } catch {
    return 0;
  }
};

export { safeCalculateMindedResources };
